import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const StImage = styled.img`
  max-width: 150px;

  @media ${breakpoints.s} {
    max-width: 200px;
  }
`

export { StImage }
